import React from "react";
import { Helmet } from "react-helmet";
import LWCLayout from "../../layouts/LWCLayout";
import FAQ from "../../components/quests/FAQ";

const QuestsTemplate = (data) => {
  const {
    pageContext: { items, slug, lang },
  } = data;

  const promoItem = items.filter((item) => item.section === "promo");
  const monthlyItems = items.filter((item) => item.section === "monthly");
  const newSectionItems = items.filter((item) => item.section === "newSection");
  const featuredQuestItems = items.filter(
    (item) => item.section === "featuredQuest",
  );
  const rangerItems = items.filter((item) => item.section === "ranger");

  return (
    <LWCLayout slug={slug}>
      <Helmet>
        <title>Trailblazer Quests | Learn new skills. Win fun prizes.</title>
        <meta property="og:title" content="Trailblazer Quests" />
        <meta
          property="og:description"
          content="Learn new skills. Win fun prizes."
        />
        <meta
          property="og:image:url"
          content="https://developer.salesforce.com/resources2/thquests/2026/2026-02-WebsiteBanner-Agentforce-1280x720.png"
        />
        <meta property="og:site_name" content="Salesforce Trailblazer" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@trailhead" />
        <meta name="twitter:title" content="Trailblazer Quests" />
        <meta
          name="twitter:description"
          content="Learn new skills. Win fun prizes."
        />
        <meta
          name="twitter:image"
          content="https://developer.salesforce.com/resources2/thquests/2026/2026-02-WebsiteBanner-Agentforce-1280x720.png"
        />
      </Helmet>

      <div>
        <tm-page class="theme--developer">
          <tm-hero-a
            title="Trailblazer Quests"
            subtitle="Learn new skills. Win fun prizes."
            cta-href="#thquests-dreamquest"
            cta-label="Explore Quests"
            img-align="bottom"
            img-alt="Trailblazer Quests"
            img-src="https://developer.salesforce.com/resources2/thquests/2026/2026-02-WebsiteBanner-Agentforce-1280x720.png"
          />

          <tm-section-a
            description="Trailhead, the free online learning platform from Salesforce, is the fun way to learn in-demand skills. While learning is its own reward, there's always room for a little extra motivation. Trailblazer Quests combine the challenge of learning new skills with the chance of winning sweet prizes."
            title="Join the Learning Adventure"
          >
            <tm-card-grid-a img-aspect="60%" img-type="left">
              <tm-grid-item
                description="Quests challenge different skills. From beginners to experts, there's a quest for everyone."
                img-src="https://developer.salesforce.com/resources2/thquests/2025/Compass_Transparent_Icon.png"
                img-alt="Choose a Quest"
                title="Choose a Quest"
              ></tm-grid-item>
              <tm-grid-item
                description="Each quest runs for a limited period of time and has specific tasks for learners to carry out."
                img-src="https://developer.salesforce.com/resources2/thquests/2025/Mountain_Transaparent_Icon.png"
                title="Complete the Challenge"
                img-alt="Complete the Challenge"
              ></tm-grid-item>
              <tm-grid-item
                description="Once you complete a quest, you’ll be entered for a chance to win fun prizes (see each quest for prize details and official rules)."
                img-src="https://developer.salesforce.com/resources2/thquests/2025/Trophy_Transaparent_Icon.png"
                title="Chance to Win"
                img-alt="Chance to Win"
              ></tm-grid-item>
            </tm-card-grid-a>
          </tm-section-a>


          <tm-section-a
            id="thquests-dreamquest"
            background="light"
            description=""
            title="Featured Quests"
          >
            <tm-promo-b
              key={`promo-quest-1`}
              title={promoItem[0].title}
              description={promoItem[0].description}
              img-src={promoItem[0].imgSrc}
              img-alt={promoItem[0].title}
              cta-href={promoItem[0].ctaHref}
              cta-title={promoItem[0].ctaLabel}
            ></tm-promo-b>
            <br /><br /><br /><br />
            <tm-promo-b
              key={`promo-quest-2`}
              title={promoItem[1].title}
              description={promoItem[1].description}
              img-src={promoItem[1].imgSrc}
              img-alt={promoItem[1].title}
              cta-href={promoItem[1].ctaHref}
              cta-title={promoItem[1].ctaLabel}
            ></tm-promo-b>
          </tm-section-a>

          <tm-section-a
            id="new-section"
            background="light"
            title=""
            description=""
          >
            <tm-card-grid-a img-aspect="60%" img-type="left">
              {newSectionItems.map((item, index) => (
                <tm-grid-item
                  key={`monthly-quest-${index}`}
                  title={item.title}
                  cta-href={item.ctaHref}
                  cta-title={item.ctaLabel}
                  description={item.description}
                  img-src={item.imgSrc}
                  img-alt={item.title}
                ></tm-grid-item>
              ))}
            </tm-card-grid-a>
          </tm-section-a>

          {/* Future will be using this promo again */}

          <tm-section-a title="Become an Agentblazer Quests">
            <tm-card-grid-a img-aspect="60%" img-type="left">
              {featuredQuestItems.map((item, index) => (
                <tm-grid-item
                  key={`primary-quest-${index}`}
                  title={item.title}
                  cta-href={item.ctaHref}
                  cta-title={item.ctaLabel}
                  description={item.description}
                  img-src={item.imgSrc}
                ></tm-grid-item>
              ))}
            </tm-card-grid-a>
          </tm-section-a>

          <tm-section-a
            id="monthly-section"
            background="light"
            title="Unlock New Skills"
            description=""
          >
            <tm-card-grid-a img-aspect="60%" img-type="left">
              {monthlyItems.map((item, index) => (
                <tm-grid-item
                  key={`monthly-quest-${index}`}
                  title={item.title}
                  cta-href={item.ctaHref}
                  cta-title={item.ctaLabel}
                  description={item.description}
                  img-src={item.imgSrc}
                  img-alt={item.title}
                ></tm-grid-item>
              ))}
            </tm-card-grid-a>
          </tm-section-a>

          {rangerItems?.length > 0 && (
            <tm-section-a
              id="ranger-section"
              background="white"
              title="Road to Ranger and Beyond"
              description=""
            >
              <tm-card-grid-a img-aspect="60%" img-type="left">
                {rangerItems.map((item, index) => (
                  <tm-grid-item
                    key={`ranger-quest-${index}`}
                    title={item.title}
                    cta-href={item.ctaHref}
                    cta-title={item.ctaLabel}
                    description={item.description}
                    img-src={item.imgSrc}
                  ></tm-grid-item>
                ))}
              </tm-card-grid-a>
            </tm-section-a>
          )}

          <tm-section-a background="light" title="Trailblazer Quests FAQ">
            <div class="slds-grid slds-grid_align-center">
              <div class="slds-size_5-of-7">
                <tm-feature-grid-a>
                  <tm-grid-item
                    cta-secondary-href={`https://trailhead.salesforce.com/${lang}/help?article=Trailblazer-Quests`}
                    cta-secondary-title="Trailblazer Quest Help Article"
                    description="Quest badges are exclusive, limited-edition virtual rewards that you can earn by completing a Trailblazer Quest. Once earned, they’ll show up in the badge section of your Trailblazer profile—just open the drop-down menu and choose “Event/Community” to see your community badges. Keep in mind that not every Quest includes a badge.
                    
                    Eligible participants will be selected at random for Salesforce certification vouchers or physical prizes. Winners will be notified via email (provided on your Trailblazer profile) around 10 days after the quest has ended. If you have not received an email from us within two weeks, it means you were not selected this time. We encourage you to continue participating in quest activities for future opportunities to win."
                    title="How do I know if I’ve won a quest prize?"
                  />
                </tm-feature-grid-a>

                <tm-feature-grid-a>
                  <tm-grid-item
                    cta-secondary-href="/quests/quests-past"
                    cta-secondary-title="Past Quests"
                    description="For full details on quests that have now ended, visit our Past Quests page."
                    title="How do I see past quests?"
                  />
                </tm-feature-grid-a>

                <tm-feature-grid-a>
                  <tm-grid-item
                    description="Every country has a set of stringent requirements around running sweepstakes and contest promotions. Some countries are more flexible with regards to how these promotions are run, but other countries either prohibit these types of promotions or impose strict requirements on running them. The countries that are ＂approved＂ are those whose requirements we are able to comply with at this time. We're currently exploring how to expand the list of eligible countries and hope to include more, as local sweepstakes law permits."
                    title="Why is my country not eligible to win monetary prizes?"
                  />
                </tm-feature-grid-a>

                <tm-feature-grid-a>
                  <tm-grid-item
                    cta-secondary-href="https://trailhead.salesforce.com/help?support=article&amp;article=Trailhead-Quests"
                    cta-secondary-title="Trailblazer Support"
                    description="If your question is not answered in this Trailblazer Help article, or need more information about a specific quest you participated in, contact us via Trailblazer Support."
                    title="What if I still have a question about Trailblazer Quests?"
                  />
                </tm-feature-grid-a>
              </div>
            </div>
          </tm-section-a>

          <tm-section-a>
            <div class="slds-grid slds-grid_align-center">
              <div class="slds-size_5-of-6">
                <FAQ items={items} page={"QUEST"} />
              </div>
            </div>
          </tm-section-a>
        </tm-page>

        <th-element-loader
          element="tm-page"
          style={{ height: "100vh" }}
        ></th-element-loader>
      </div>
    </LWCLayout>
  );
};

export default QuestsTemplate;
